<div
  style="min-height: 600px"
  (drop)="drop($event)"
  class="mb-10px"
  (dragover)="dragOver($event)"
  (dragenter)="dragEnter($event)"
  (dragleave)="dragLeave($event)">
  <app-please-wait [hidden]="hidePleaseWait"></app-please-wait>

  <div class="flex justify-center mb-3">
    <bl-frontend-segmentedbutton [buttons]="sectionButtons" density="slim"></bl-frontend-segmentedbutton>
  </div>

  <app-file-browser-shared-section *ngIf="activeSection === 'shared'" [client]="_client"></app-file-browser-shared-section>

  <app-file-browser-internal-section
    *ngIf="activeSection === 'internal'"
    [client]="_client"
    [sendingFiles]="sendingFiles"
    [currentPath]="pathState.currentRealPath"
    [columns]="columns"
    [files]="files"
    [loading]="loading"
    [(selectedRow)]="selectedRow"
    [(directory)]="directory"
    [contextMenuItems]="contextMenuItems"
    [(displayDeleteFile)]="displayDeleteFile"
    [pendingDeletionDocument]="pendingDeletionDocument"
    [(displayRenameDialog)]="displayRenameDialog"
    [pendingRenameDocument]="pendingRenameDocument"
    (loadFiles)="loadFiles()"
    (upDir)="upDir()"
    (uploadFiles)="onUploadFiles($event)"
    (rowUnselect)="onRowUnselect($event)"
    (rowDblClick)="onRowDblClick($event)"
    (deleteFile)="deleteFile($event)"
    (createDir)="createDir()"
    (afterDeleteDialog)="afterDeleteDialog($event)"
    (afterRenameDialog)="afterRenameDialog($event)">
  </app-file-browser-internal-section>
</div>
